<script lang="ts">
	import classNames from 'classnames';
	import { getCartIconContext } from '#lib/features/checkout/utils/getCartIconContext/index.js';
	import { getCheckoutContext } from '#lib/features/checkout/utils/getCheckoutContext/index.js';
	import { isVisibleCartItem } from '#lib/features/checkout/utils/isVisibleCartItem/index.js';
	import { getLiveDropInfoContext } from '#lib/features/live-drop-info/LiveDropInfoContext/utils/getLiveDropInfoContext/getLiveDropInfoContext.js';
	import { page } from '$app/state';
	import { CartIcon } from '$global/assets/icons/CartIcon';
	import { Txt } from '$global/components/Txt';

	interface Props {
		dataCy: string;
		class?: string;
		disableCart?: boolean;
	}

	let { disableCart = false, ...props }: Props = $props();

	const {
		cartDrawer: {
			states: { open },
		},
		cartItems: { animated, totalNbItems, cartItems },
	} = getCheckoutContext();

	const { dropTypes } = getCartIconContext();
	const { liveDropInfoCtx } = getLiveDropInfoContext();
	const isOnPrimaryRoute = $derived(!!page.route.id?.startsWith('/primary'));

	const visibilityContext = $derived({
		isOnPrimaryRoute,
		liveDropInfo: liveDropInfoCtx.liveDropInfo ?? undefined,
		dropTypes: $dropTypes,
	});

	const visibleNbItems = $derived(
		isOnPrimaryRoute
			? Object.values($cartItems)
					.filter((item) => isVisibleCartItem(item.groupId, visibilityContext))
					.reduce((acc, item) => acc + item.quantity, 0)
			: $totalNbItems
	);
</script>

<button
	onclick={() => open.set(true)}
	{...props}
	class={classNames(
		`relative outline-none`,
		$animated ? 'animate-icon-jump' : '',
		props.class,
		disableCart ? 'pointer-events-none' : ''
	)}
	data-cy={props.dataCy}
>
	<CartIcon />
	{#if visibleNbItems && !disableCart}
		<div
			class={classNames(
				'absolute top-[0.5rem] right-[-0.375rem] flex h-[0.875rem] items-center justify-center rounded-full bg-red-500 lg:top-[-0.125rem]',
				visibleNbItems > 99 ? 'w-[1.25rem]' : 'w-[0.875rem]'
			)}
		>
			<Txt
				class="body3 text-gray-0 text-[0.625rem] leading-[0.625rem]"
				dataCy={`${props.dataCy}-count`}
			>
				{visibleNbItems}
			</Txt>
		</div>
	{/if}
</button>
